



















import {
  computed, ComputedRef, defineComponent,
} from '@nuxtjs/composition-api';
import { useTraverseCategory } from '~/modules/catalog/category/helpers/useTraverseCategory';
import type { CategoryTree } from '~/modules/GraphQL/types';
import { useUiHelpers } from '~/composables';
import CategoryTile from '~/modules/catalog/category/components/CategoryTile.vue';

export default defineComponent({
  name: 'CategoryTileGrid',
  components: {
    CategoryEmptyResults: () => import('~/modules/catalog/category/components/CategoryEmptyResults.vue'),
    CategoryTile,
  },
  setup() {
    const { getCatLink } = useUiHelpers();
    const { activeCategory } = useTraverseCategory();
    const list: ComputedRef<CategoryTree[]> = computed(() => activeCategory.value?.children || []);
    const isEmpty = computed(() => list.value.length === 0);

    return {
      list,
      isEmpty,
      getCatLink,
    };
  },
});
